"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@tiendanube/icons");
var Menu_Item_1 = __importDefault(require("./Menu.Item"));
var Menu_Section_1 = __importDefault(require("./Menu.Section"));
var __1 = require("..");
require("./Menu.css");
function BaseMenu(_a) {
    var title = _a.title, href = _a.href, customHeader = _a.customHeader, children = _a.children, footer = _a.footer;
    var hasHeader = title && href;
    var hasCustomHeader = !!customHeader;
    return (React.createElement(React.Fragment, null,
        (hasHeader || hasCustomHeader) && (React.createElement("div", { className: "nimbus--menu-header", "data-testid": "nimbus--menu__header" },
            hasCustomHeader && customHeader,
            !hasCustomHeader && (React.createElement(__1.Stack, { justify: "space-between" },
                React.createElement(__1.Stack.Item, { fill: true },
                    React.createElement(__1.Stack, { spacing: "tight" },
                        React.createElement(__1.Stack.Item, null,
                            React.createElement(icons_1.TiendanubeIcon, { size: "medium" })),
                        React.createElement(__1.Stack.Item, null,
                            React.createElement(__1.Title, { type: "h5" }, title || "")))),
                React.createElement(__1.Stack.Item, null,
                    React.createElement(__1.IconButton, { icon: icons_1.ExternalLinkIcon, ariaLabel: title || "", href: href || "" })))))),
        React.createElement("div", { className: "nimbus--menu-body" }, children),
        footer && (React.createElement("div", { className: "nimbus--menu-footer", "data-testid": "nimbus--menu__footer" },
            React.createElement("button", { type: "button", onClick: footer === null || footer === void 0 ? void 0 : footer.onClick, className: "nimbus--menu-item" },
                !!(footer === null || footer === void 0 ? void 0 : footer.icon) && React.createElement(footer === null || footer === void 0 ? void 0 : footer.icon), footer === null || footer === void 0 ? void 0 :
                footer.label)))));
}
BaseMenu.Section = Menu_Section_1.default;
BaseMenu.Item = Menu_Item_1.default;
exports.default = BaseMenu;
//# sourceMappingURL=BaseMenu.js.map